

import { FabrixIcon } from "../../fabrix/common/icons";
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";

import { ModuleInfo } from "../../fabrix/types";
import { icons } from "./icons";
import translationJson from "./translations.json";

const moduleRoutes = (): ModuleInfo => {
  return {
    path: "/persal/",
    label: "PERSAL",
    name: "persal",
    id: "a3e42291-894d-49ff-b621-f6aa8431e75f",
    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: (
          <RequireAuth roles={[]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    translations: translationJson,
    icons: icons,
    children: [
      {
        path: "/persal/",
        label: "HOME",
        name: "home",
        id: "7497a6cf-cc84-4ee8-aa40-e1187f871306",

        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/persal/documentation/user",
        label: "PERSAL_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "c854c29e-99e9-4c25-aab0-6640adf772ea",
        newTab: true,

        lazy: async () => {
          const Page = (await import("./routes/documentation/user")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
      {
        path: "/persal/documentation/user/:file",
        label: "PERSAL_DOCUMENTATION",
        name: 'user-documentation',
        icon: FabrixIcon.documentation,
        id: "a6a81cf4-81f1-4f09-a73d-ca5dfd7f4543",
        newTab: true,

        lazy: async () => {
          const Page = (await import("./routes/documentation/user")).default;
          return {
            element: <RequireAuth roles={[]}><Page /></RequireAuth>,
          }
        }
      },
    ],
  };
};

export default moduleRoutes;
